import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { sanitizeDisplayName } from '@happenings/components/util';
import AccountSettingsForm from './AccountSettingsForm';
import LoadingIcon from '../common/LoadingIcon';

const AccountSettings = (props) => {
  useEffect(() => {
    props.fetchUserByUsername(props.currentUser.username);
  }, []);


  const handleSubmit = (formState) => {
    const sanitizedDisplayName = sanitizeDisplayName(formState.displayName);
    formState.displayName = sanitizedDisplayName;
    props.updateUserInfo(props.userInfo.id, formState);
  };

  const toggleDeleteAccountModal = () => {
    if (props.deleteAccountModalOpen) {
      props.closeDeleteAccountModal();
    } else {
      props.openDeleteAccountModal();
    }
  };

  const { email, username, displayName, entityUrl, bio, isPrivate, userType } = props.userInfo;
  return props.loaded ? (
    <div className="account-settings-container">
      <AccountSettingsForm
        username={username}
        displayName={displayName}
        email={email}
        entityUrl={entityUrl}
        bio={bio}
        userType={userType}
        isPrivate={isPrivate}
        onSubmit={handleSubmit}
      />
      <div className="submit-btn-white" role="button" onClick={props.logOut}>
        Sign Out
      </div>
      <div className="submit-btn-red" role="button" onClick={toggleDeleteAccountModal}>
        Delete Account
      </div>
    </div>
  ) : <LoadingIcon />;
}

AccountSettings.propTypes = {
  currentUser: PropTypes.shape({
    id: PropTypes.number,
    token: PropTypes.string,
    username: PropTypes.string,
  }).isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.number,
    email: PropTypes.string,
    bio: PropTypes.string,
    entityUrl: PropTypes.string,
    isPrivate: PropTypes.bool,
    userType: PropTypes.string,
    username: PropTypes.string,
    displayName: PropTypes.string,
  }),
  logOut: PropTypes.func.isRequired,
  loaded: PropTypes.bool.isRequired,
  fetchUserByUsername: PropTypes.func.isRequired,
  updateUserInfo: PropTypes.func.isRequired,
  deleteAccountModalOpen: PropTypes.bool.isRequired,
  openDeleteAccountModal: PropTypes.func.isRequired,
  closeDeleteAccountModal: PropTypes.func.isRequired,
};

AccountSettings.defaultProps = {
  userInfo: {},
};

export default AccountSettings;
